import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFilterList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={8}
    fill="none"
    viewBox="0 0 10 8"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.125 7.15A.51.51 0 0 1 3.751 7a.504.504 0 0 1-.151-.372c0-.148.05-.273.15-.375a.504.504 0 0 1 .375-.153h1.75a.51.51 0 0 1 .374.15c.1.1.151.224.151.372s-.05.273-.151.375a.504.504 0 0 1-.374.153zm-2.1-2.625a.51.51 0 0 1-.374-.15.504.504 0 0 1-.151-.372c0-.148.05-.273.15-.375a.504.504 0 0 1 .375-.153h5.95a.51.51 0 0 1 .374.15c.1.1.151.224.151.372s-.05.273-.151.375a.504.504 0 0 1-.374.153zM.625 1.9a.51.51 0 0 1-.374-.15.504.504 0 0 1-.151-.372c0-.148.05-.273.15-.375A.504.504 0 0 1 .626.85h8.75a.51.51 0 0 1 .374.15c.1.1.151.224.151.372s-.05.273-.151.375a.504.504 0 0 1-.374.153z"
    />
  </svg>
);
export default SvgFilterList;
